import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService, ClientProfileService, ProjectService,} from '../../_services/index';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ValidateUrl} from "../../helpers/url.validator";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {RecommendedSolutionService} from "../../_services/recommendedSolution.service";
import {ReferenceResourceService} from "../../_services/referemceResource.service";

@Component({
    standalone: false,
  selector: 'add-link-reference-resource-component',
  templateUrl: 'add-link-reference-resource.component.html'
})

export class AddLinkReferenceResourceComponent implements OnInit {
  quizForm: FormGroup;
  url: string = '';
  entity;

  constructor(
    formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddLinkReferenceResourceComponent>,
    public projectService: ProjectService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public service: ReferenceResourceService,
    public router: Router,
    public clientProfileService: ClientProfileService,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {
    let entity = this.data.entity || {};
    this.entity = entity;

    this.quizForm = formBuilder.group({
      referenceResourceId: [entity.referenceResourceId || 0, '', []],
      name: [entity.name || '', [Validators.required]],
      url: [entity.url || '', [Validators.required, ValidateUrl]],
      sourceProvider: [entity.sourceProvider || '', [Validators.required]],
      listId: [entity.listId || '', [Validators.required]],
      notes: [entity.notes || '', []],
    });
  }

  ngOnInit() {
  }

  generate(): void {
    if (!this.quizForm.valid) return;
    this.dialogRef.close({value: this.quizForm.value});
  }

  onClose(): void {
    this.dialogRef.close();
  }

  addReference() {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
    };

    const selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.service.addReference(this.entity.referenceResourceId, data.controlItemId).subscribe(id => {
          this.entity.controlItemReferences.push({
            controlItemReferenceResourceId: id,
            controlId: data.complianceAreaControlId,
            complianceAreaName: data.complianceAreaName
          })
        });
      }
    });
  }

  removeReference(c) {
    this.service.removeReference(c.controlItemReferenceResourceId).subscribe(id => {
      this.entity.controlItemReferences = this.entity.controlItemReferences.filter(v => v.controlItemReferenceResourceId !== c.controlItemReferenceResourceId);
    });
  }
}
